const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

/**
 * Résout l'URL d'affichage d'une image produit.
 *
 * - Images du fournisseur : URL absolue (https://...) → renvoyée telle quelle.
 * - Images téléversées depuis le back-office : chemin relatif (/api/uploads/...)
 *   → préfixé par l'URL du backend. Indispensable en local, où le frontend
 *   (port 3000) et le backend (port 8001) sont sur des origines différentes.
 */
export function resolveImageUrl(url) {
  if (!url) return '';
  if (/^(https?:)?\/\//.test(url) || url.startsWith('data:')) return url;
  return `${BACKEND_URL}${url}`;
}
